import PublicRoutes from './publicRoutes';
import PrivateRoutes from './privateRoutes';
import { connect } from 'react-redux';

const Routing = ({ user }) => {
  return <>{user?.access_token ? <PrivateRoutes /> : <PublicRoutes />}</>;
};

const mapStateToProps = (state) => {
  return {
    user: state.common.user
  };
};

export default connect(mapStateToProps)(Routing);
